import {Component, Input, Output, EventEmitter, AfterViewChecked, OnDestroy} from '@angular/core';

import { CommonDataService } from 'app/services/common-data.service';
import { BufferGraphService } from 'app/buffer-graph/services/buffer-graph.service';
import { ChangeBufferItem } from 'app/buffer-graph/models/chage-buffer-item';
import {BGChartType} from "../../models/b-g-chart-type";
import {GraphAutoMakeOptions} from "../../models/graph-auto-make-options";

@Component({
    selector: 'buffer-graph-modal',
    templateUrl: './buffer-graph-modal.component.html',
    styleUrls: ['./buffer-graph-modal.component.css']
})
export class BufferGraphModalComponent implements AfterViewChecked, OnDestroy {
    constructor(private readonly commonData: CommonDataService, private readonly graphService: BufferGraphService) {
        this.close = new EventEmitter<void>();
    }

    @Input() public itemId: number;
    @Input() public itemIds: number[];
    @Input() public isAdmin: boolean;
    @Input() public type: BGChartType;
    @Input() public options?: GraphAutoMakeOptions;

    @Output()
    private readonly close: EventEmitter<void>;

    private shown: boolean;

    private canDrawChart: boolean;

    public showLoadingImg: boolean;

    private temporaryHidden: boolean;

    public changeBufferItem: ChangeBufferItem;

    ngAfterViewChecked(): void {
        if (this.shown)
            return;

        this.showModal();
        this.shown = true;
    }

    ngOnDestroy(): void {
        this.hideModal();
    }

    //# show popup
    private showModal = (): void => {
        $('#bg-modal').on('shown.bs.modal',
            (e) => {
                $(e.target).off('shown.bs.modal');

                this.canDrawChart = true;
            }).on('hidden.bs.modal',
            (e) => {
                $(e.target).off('hidden.bs.modal');

                if (!this.temporaryHidden)
                    this.close.emit();
                else
                    this.temporaryHidden = false;
            }).modal({ backdrop: 'static', keyboard: false });
    }

    public get chartType(): typeof BGChartType{
        return BGChartType;
    }

    //# hide popup
    private hideModal = (): void => {
        $('#bg-modal').modal('hide');
    }

    //# show errors
    private showErrors = (errors: string[], onOk?: () => void): void => {
        this.temporaryHidden = true;
        this.commonData.showErrors(errors, onOk || this.showModal );
    }

    //# show change buffer form (not use now)
    private showChangeBufferDialog = (): void => {
        this.showLoadingImg = true;

        this.graphService.getChangeBufferData(this.itemIds[0]).subscribe(data => {

                if (data == null || data.accessDenied) {
                    this.showLoadingImg = false;

                    this.commonData.translateService.get(data && data.accessDenied ? 'AccessDenied' : 'ChangeBufferError')
                        .subscribe(error => this.showErrors([error]));
                    return;
                }

                this.temporaryHidden = true;
                this.hideModal();
                this.changeBufferItem = data.item;
                this.showLoadingImg = false;
            },
            e => {
                this.showLoadingImg = false;
                this.showErrors([e.message || e]);
            });
    }


    private onShowLoadingImg = (visible: boolean): void => {
        this.showLoadingImg = visible;
    }

    //# show errors, if they exist in chart
    public onShowErrors = (data: { errors: string[], isOnInitiating?: boolean }): void => {
        this.showErrors(data.errors, () => {this.hideModal(); this.close.emit()});
    }

    //# show change buffer form
    public onChangeBufferClick = (): void => {
        this.showChangeBufferDialog();
    }

    public onChangeBufferClose = (): void => {
        this.changeBufferItem = null;
        this.showModal();
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/buffer-graph-modal.component/buffer-graph-modal.component.ts